import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { InputNumberModule } from 'primeng/inputnumber';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Subscription } from 'rxjs';
import { TooltipIconComponent } from 'src/app/shared/tooltip-icon/tooltip-icon.component';
import { CruiseSubtype } from 'src/app/trip-calculator/models/transport';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
@Component({
  selector: 'app-cruise-form',
  imports: [
    SelectButtonModule,
    TranslocoPipe,
    FormsModule,
    ReactiveFormsModule,
    TooltipIconComponent,
    SelectModule,
    InputNumberModule,
  ],
  templateUrl: './cruise-form.component.html',
})
export class CruiseFormComponent implements OnInit {
  transportFormService = inject(TransportFormService);
  private translocoService = inject(TranslocoService);
  options: { label: string; value: string }[] = [];
  cruiseSubtypeSubscription?: Subscription;
  showAdvancedOptions: boolean = false;

  initializeOptions() {
    this.options = [];
    Object.values(CruiseSubtype).forEach((value) => {
      this.options.push({
        value: value,
        label: this.translocoService.translate(`cruise.${value}`),
      });
    });
  }
  onModeChange() {
    if (this.showAdvancedOptions) {
      const subtype =
        this.transportFormService.transportForm.get('subtype')?.value;
      this.setMeanDistance(subtype);
    } else {
      this.transportFormService.transportForm
        .get('distancePerDay')
        ?.setValue(null);
      this.transportFormService.transportForm
        .get('daysWithoutTravel')
        ?.setValue(null);
    }
  }
  setShowAdvancedOptionsValue() {
    if (
      this.transportFormService.transportForm.get('distancePerDay')?.value !==
        null ||
      this.transportFormService.transportForm.get('daysWithoutTravel')
        ?.value !== null
    ) {
      this.showAdvancedOptions = true;
    }
  }

  ngOnInit() {
    this.transportFormService.createCruiseControls();
    this.transportFormService.createSubtypeControl();
    this.initializeOptions();
    this.typechangeSubscription();
    this.setShowAdvancedOptionsValue();
  }

  typechangeSubscription() {
    this.transportFormService.transportForm
      .get('subtype')
      ?.valueChanges.subscribe({
        next: (value) => {
          if (this.showAdvancedOptions) {
            this.setMeanDistance(value);
          }
        },
        error: (error) => {
          console.error('Error subscribing to subtype value changes', error);
        },
      });
  }
  setMeanDistance(subtype: CruiseSubtype) {
    switch (subtype) {
      case CruiseSubtype.Medium:
        this.transportFormService.transportForm
          .get('distancePerDay')
          ?.setValue(468);
        break;
      case CruiseSubtype.Small:
        this.transportFormService.transportForm
          .get('distancePerDay')
          ?.setValue(350);
        break;
      case CruiseSubtype.River:
        this.transportFormService.transportForm
          .get('distancePerDay')
          ?.setValue(200);
        break;
      default:
        this.transportFormService.transportForm
          .get('distancePerDay')
          ?.setValue(468);
        break;
    }
  }
}
